
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

interface DeleteQuestionDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onDisableInstead: () => void;
  questionText: string;
}

export function DeleteQuestionDialog({
  isOpen,
  onClose,
  onConfirm,
  onDisableInstead,
  questionText
}: DeleteQuestionDialogProps) {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Question</AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <p>Are you sure you want to permanently delete this question?</p>
            <div className="bg-muted p-3 rounded-md">
              <p className="font-medium text-sm">"{questionText}"</p>
            </div>
            <p className="text-sm text-destructive">
              ⚠️ This action cannot be undone. All responses to this question will be affected.
            </p>
            <p className="text-sm text-muted-foreground">
              Consider disabling the question instead to preserve existing data while hiding it from new assessments.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2">
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <Button 
            variant="outline" 
            onClick={onDisableInstead}
            className="text-amber-600 hover:text-amber-700"
          >
            Disable Instead
          </Button>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive hover:bg-destructive/90"
          >
            Delete Permanently
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
